import { ThumbsUp, ThumbsDown } from "lucide-react";
import EVStationTags from "./tags";

export default function Ratings({
  totalRatings,
  positiveRatings,
  negativeRatings,
  tags,
}: {
  totalRatings: number;
  positiveRatings: number;
  negativeRatings: number;
  tags: any;
}) {
  const positivePercentage = (positiveRatings / totalRatings) * 100;

  // Function to determine the color based on the percentage
  const getColorClass = (percentage: number): string => {
    if (percentage <= 30) return "bg-red-500";
    if (percentage <= 60) return "bg-yellow-500";
    return "bg-green-500";
  };

  const colorClass = getColorClass(positivePercentage);

  return (
    <div className="w-full rounded-lg border border-border bg-white p-4 shadow-md">
      <h2 className="mb-4 text-xl font-semibold text-card-foreground">
        Avaliações ({totalRatings})
      </h2>
      {totalRatings > 0 ? (
        <div className="flex items-center space-x-4">
          <div className="flex items-center space-x-1">
            <ThumbsUp className="h-5 w-5 text-green-500" />
            <span className="text-sm font-medium text-gray-600">
              {positiveRatings}
            </span>
          </div>
          <div className="relative flex-1">
            <div className="h-3 w-full rounded-full bg-gray-200">
              <div
                className={`${colorClass} h-3 rounded-full`}
                style={{ width: `${positivePercentage}%` }}
              ></div>
              <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform text-xs font-semibold text-white">
                {positivePercentage.toFixed(0)}%
              </div>
            </div>
          </div>
          <div className="flex items-center space-x-1">
            <span className="text-sm font-medium text-gray-600">
              {negativeRatings}
            </span>
            <ThumbsDown className="h-5 w-5 text-red-500" />
          </div>
        </div>
      ) : (
        <div>
          <p>Não há avaliações</p>
        </div>
      )}
      {tags && tags.length > 0 && (
        <div className="mt-4 flex flex-col space-y-2">
          <div className="text-sm font-semibold text-gray-600">
            O que os usuários dizem?
          </div>
          <EVStationTags tags={tags} />
        </div>
      )}
    </div>
  );
}
